var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.81543,
    width: 22,
    height: 22,
    fill: "url(#pattern0_58_56)",
    fillOpacity: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_58_56",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_58_56",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_58_56",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAAAXNSR0IArs4c6QAAA01JREFUeF7t3L2KVEEQBeBTBv4smgs+kYGg2YKJkZGBoQrGmikYLQi+gGAovpBgqogKQmnjXVzHmdnunjrVP7c23bmnqr9b08vMNlcQPy4C4lIliiCgnYYgoAPaScCpTEx0QDsJOJWJiQ5oJwGnMjHRAe0k4FQmJno0aFW9AuAlgLsAvgF4A+CpiPyoXQsjs7aXQ68zm2hVPQFwf6Oh9wDu1GIzMg8Fq73eBFpVU85nAFe3NFKFzcisRbK4zgQ6NaKqCfrajqZqsc0zLdBqMiyhXwB4uKeJYmxVNc+sQbK4xhL6EoB3AG5aYauqeaYFWk2GGfSyfVwE8BbArT3NfABwW0S+5zSsquaZOXWtX2MKHdi7b485dGBvx6ZAB/b/2DTowP4Xmwod2H+x6dCB/QfbBTqwHaHXju020ae7FeMDCCOz+w8sOQ0yYBiZOWvJfY37RK91sptBr23Pbgq9Juzm0GvB7gJ6DdjdQM+O3RX0zNjdQc+K3SX0jNjdQs+G3TX0TNjdQ8+CPQT0DNjDQC/Y5gdqvA7pDAVdgP389wnWx7lfYWZiF2Vu1h4OOnMb+SQi13OhWZln688K/VFEbhhDF2cODZ35Nn8mIk9yoRmZQ28dmSBFx4MZmdtu8DBbB+N/gozMXe+iIaAZIIzMfVtV99AMEEbmeX8PuoZmgDAyz0NOv+8WmgHCyMxB7haaAcLIzEXuEpoBwsgsQe4OmgHCyCxF7gqaAcLIrEHuBpoBwsisRe4CmgHCyDwEuTk0A4SReShyU2gGCCPTArkZNAOEkWmF3ASaAcLItER2h2aAMDKtkV2hGSCMTAayGzQDhJHJQnaBZoAwMpnIdGgGCCOTjUyFZoAwMj2QadAMEEamFzIFmgHCyPRENodmgDAyvZFNoRkHURiZLZCtoV8BeLBnIUUniFKOqppnDg2tqhcAfAFwtGMhNcjmma2QzSZ6gf4K4PKWxRQjL9OcoE0zh4deYNLzou9tLKYK+TRDVc0zW2GbHaBR1fRI47SnHgP4CeA1gEe1z45ebp555vDQZ6ZQREQtF5SeJW2dadlfTpbZROcUW/NrAtrp7gd0QDsJOJWJiQ5oJwGnMjHRAe0k4FQmJjqgnQScysREO0H/AhmHHIjc8JxOAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleRight);
export default __webpack_public_path__ + "static/media/DoubleRight.de1340174fa4501d1e78fd61ade5205b.svg";
export { ForwardRef as ReactComponent };